import dynamic from "next/dynamic";

const VisualSkeleton = () => (
  <div className="bg-foreground/[0.03] h-full w-full animate-pulse rounded-lg" />
);

const MobileProxiesVisual = dynamic(
  () => import("./mobile-proxies-visual").then((m) => m.MobileProxiesVisual),
  { ssr: false, loading: VisualSkeleton }
);
const ResidentialProxiesVisual = dynamic(
  () => import("./residential-proxies-visual").then((m) => m.ResidentialProxiesVisual),
  { ssr: false, loading: VisualSkeleton }
);
const DatacenterProxiesVisual = dynamic(
  () => import("./datacenter-proxies-visual").then((m) => m.DatacenterProxiesVisual),
  { ssr: false, loading: VisualSkeleton }
);
const IspProxiesVisual = dynamic(
  () => import("./isp-proxies-visual").then((m) => m.IspProxiesVisual),
  { ssr: false, loading: VisualSkeleton }
);

export { MobileProxiesVisual, ResidentialProxiesVisual, DatacenterProxiesVisual, IspProxiesVisual };

export type ProductItem = {
  id: string;
  Visual: React.ComponentType<{ reduced: boolean; hovered: boolean }>;
  name: string;
  description: string;
  bullets: string[];
  href: string;
  cta: string;
  highlight: boolean;
  badge: string | null;
  comingSoon?: boolean;
};

export const mainProducts: ProductItem[] = [
  {
    id: "mobile",
    Visual: MobileProxiesVisual,
    name: "Mobile Proxies",
    description: "Premium 4G/5G IPs, ethically sourced and fully compliant.",
    bullets: ["Premium pooled mobile IPs", "City and ASN/ISP targeting", "99.5%+ success rate"],
    href: "/proxy-server/mobile-proxies",
    cta: "Get Mobile Proxies",
    highlight: true,
    badge: null,
  },
  {
    id: "residential",
    Visual: ResidentialProxiesVisual,
    name: "Residential Proxies",
    description: "Ethically sourced residential IPs across 195+ countries",
    bullets: [
      "195+ countries with city-level targeting",
      "HTTPS & SOCKS5 support",
      "Bandwidth rollover, no wasted GBs",
    ],
    href: "/proxy-server/residential-proxies",
    cta: "Get Residential Proxies",
    highlight: false,
    badge: null,
  },
];

export const stackedProducts: ProductItem[] = [
  {
    id: "datacenter",
    Visual: DatacenterProxiesVisual,
    name: "Datacenter Proxies",
    description:
      "High-speed datacenter IPs from Tier-IV facilities, built for volume at a lower cost per IP.",
    bullets: [
      "1 Gbps speeds with 99.9% target uptime",
      "IPv4 & IPv6 across global regions",
      "HTTPS & SOCKS5 support",
    ],
    href: "#",
    cta: "Join Waitlist",
    highlight: false,
    badge: "Coming Soon",
    comingSoon: true,
  },
  {
    id: "isp",
    Visual: IspProxiesVisual,
    name: "ISP Proxies",
    description:
      "Static residential IPs hosted on datacenter infrastructure — speed plus authenticity.",
    bullets: ["Sticky long-lived sessions", "Residential trust scores", "Datacenter speeds"],
    href: "#",
    cta: "Join Waitlist",
    highlight: false,
    badge: "Coming Soon",
    comingSoon: true,
  },
];

export const products: ProductItem[] = [...mainProducts, ...stackedProducts];
